import React from 'react';

import Button from '../../Button/Button';

export interface VerificationButtonsProps {
  onSkip?: () => void;
  showSkipButton?: boolean;
  isVerifyDisabled: boolean;
  isLoading: boolean;
}

const VerificationButtons: React.FC<VerificationButtonsProps> = ({
  onSkip,
  showSkipButton,
  isVerifyDisabled,
  isLoading
}) => {
  if (showSkipButton && onSkip) {
    return (
      <div className="flex justify-center">
        <div className="flex gap-3 w-[334px]">
          <Button
            type="submit"
            disabled={isVerifyDisabled}
            isLoading={isLoading}
            className="flex-1"
          >
            Verify
          </Button>
          <Button
            type="button"
            variant="outline"
            onClick={onSkip}
            disabled={isLoading}
            className="flex-1"
          >
            Skip for now
          </Button>
        </div>
      </div>
    );
  }

  return (
    <div className="flex justify-center">
      <Button
        type="submit"
        disabled={isVerifyDisabled}
        isLoading={isLoading}
        className="w-[334px]"
      >
        Verify
      </Button>
    </div>
  );
};

export default VerificationButtons;

